import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule, DoBootstrap } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AddToWatchlistComponent } from './app.component';
import { createCustomElement } from '@angular/elements';
import { tokenInterceptorProvider } from './providers/token-interceptor-config';
import { WindowRefService } from './service/window-ref/window-ref.service';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ButtonModule } from '@vg-constellation/angular-17/button';
import { ModalDialogModule } from '@vg-constellation/angular-17/modal-dialog';
import { CheckboxModule } from '@vg-constellation/angular-17/checkbox';
import { LinkModule } from '@vg-constellation/angular-17/link';
import { IconModule } from '@vg-constellation/angular-17/icon';
import { InputModule } from '@vg-constellation/angular-17/input';
import { LabelModule } from '@vg-constellation/angular-17/label';
import { HintErrorModule } from '@vg-constellation/angular-17/hint-error';
import { ChipModule } from '@vg-constellation/angular-17/chip';
import { WatchlistService } from './service/watchlist.service';
import { CookieService } from 'ngx-cookie-service';
import { BannerModule } from '@vg-constellation/angular-17/banner';

@NgModule({
  declarations: [AddToWatchlistComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    LinkModule,
    ButtonModule,
    ModalDialogModule,
    CheckboxModule,
    IconModule,
    BannerModule,
    InputModule,
    LabelModule,
    HintErrorModule,
    ChipModule,
  ],
  providers: [WatchlistService, tokenInterceptorProvider, CookieService, WindowRefService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddToWatchlistModule implements DoBootstrap {
  constructor(private injector: Injector) {
    const customComponent = createCustomElement(AddToWatchlistComponent, { injector });
    customElements.define('add-to-wl', customComponent);
  }

  ngDoBootstrap() {}
}
